import ENDPOINTS from 'api/endpoints';
import { doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  TemplateProject,
  TemplateProjectDetailed,
  TemplateProjectModificationRequest,
} from './types';

export const listTemplateProjects = () => {
  return doGet<TemplateProject[]>(
    ENDPOINTS.TEMPLATE_PROJECTS,
    LOGGER_TYPE.JUPITER,
    { version: 'v2' },
  );
};

export const getTemplateProject = (accountId: string, projectId: string) => {
  return doGet<TemplateProjectDetailed>(
    generateNextPath(ENDPOINTS.TEMPLATE_PROJECT, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    { version: 'v2' },
  );
};

export const updateTemplateProject = (
  accountId: string,
  projectId: string,
  data?: TemplateProjectModificationRequest,
) => {
  return doPost<TemplateProjectDetailed>(
    generateNextPath(ENDPOINTS.TEMPLATE_PROJECT, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    data ?? {},
    { version: 'v2' },
  );
};
